import BaseModel from '../core/BaseModel'
export default class BookingRoundModel extends BaseModel {

    constructor() {
        super({
                name: "booking_round",
                tableName: 'booking_round',
                label: "Booking round"
            },
            {
                stt: {
                    name: "stt",
                    label: "No.",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                part_id: {
                    display: false
                },
                booking_id: {
                    display: false
                },
                week_id: {
                    display: false
                },
                date_start_book: {
                    display: false
                }
            })
    }

}